import { connect } from 'react-redux';

export function Header(props) {
  const { currentTrialName, currentLibraryName, currentCollectionName, confirmDialogCompleted, awsConnectionStatus } =
    props;

  return (
    <div className="uploader__trial-details">
      <div>
        <i
          className={`fa ${
            !confirmDialogCompleted
              ? 'fa-unlock-alt'
              : awsConnectionStatus !== 'Success'
              ? 'fa-exclamation-triangle'
              : 'fa-cloud-upload'
          }`}
        />
      </div>

      {currentTrialName !== '' && (
        <div>
          <span className="uploader__trial-heading">TRIAL:</span>
          <span className="uploader__trial-title">{currentTrialName}</span>
        </div>
      )}

      <div>
        <span className="uploader__trial-heading">LIBRARY:</span>
        <span className="uploader__trial-title">{currentLibraryName}</span>
      </div>

      {currentCollectionName !== '' && (
        <div>
          <span className="uploader__trial-heading">COLLECTION:</span>
          <span className="uploader__trial-title">{currentCollectionName}</span>
        </div>
      )}
    </div>
  );
}

export const mapStateToProps = (state) => {
  return {
    currentTrialName: state.internal.currentTrialName,
    currentLibraryName: state.internal.currentLibraryName,
    currentCollectionName: state.internal.currentCollectionName,
    confirmDialogCompleted: state.internal.confirmDialogCompleted,
    awsConnectionStatus: state.internal.awsConnectionStatus,
  };
};

export default connect(mapStateToProps)(Header);
